/* First fold: expose the header + announcement height so the hero can size
   itself to leave the marquee strip visible under it. */
(() => {
  const set = () => {
    const hero = document.querySelector('.a-hero');
    if (!hero) return;
    const top = hero.getBoundingClientRect().top + window.scrollY;
    document.documentElement.style.setProperty('--a-hero-top', `${Math.round(top)}px`);
  };
  set();
  addEventListener('resize', set, { passive: true });
  addEventListener('load', set);
})();

/* Asama home hero slider. Crossfades every 6s; hover or focus pauses it, any
   click on the controls stops autoplay for good, reduced motion never starts it. */
(() => {
  const INTERVAL = 6000;
  const init = (root) => {
    root.querySelectorAll('[data-hero-slides]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const slides = [...el.querySelectorAll('.a-hero-slide')];
      const dots = [...el.querySelectorAll('[data-go]')];
      if (slides.length < 2) return;
      el.style.setProperty('--a-hero-interval', INTERVAL + 'ms');
      let i = 0, timer = null;
      const auto = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => {
          const on = k === i;
          s.classList.toggle('is-active', on);
          s.toggleAttribute('aria-hidden', !on);
          s.querySelectorAll('a').forEach((a) => { if (a.classList.contains('a-hero__shop')) a.tabIndex = on ? 0 : -1; });
          s.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
        });
        dots.forEach((d, k) => {
          d.classList.toggle('is-active', k === i);
          if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
          // restart the progress bar
          const bar = d.querySelector('span'); bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
        });
      };
      const start = () => { if (auto && !el.classList.contains('is-stopped')) { clearInterval(timer); timer = setInterval(() => show(i + 1), INTERVAL); } };
      const stop = () => { clearInterval(timer); el.classList.add('is-stopped'); };
      el.querySelector('[data-prev]').addEventListener('click', () => { stop(); show(i - 1); });
      el.querySelector('[data-next]').addEventListener('click', () => { stop(); show(i + 1); });
      dots.forEach((d) => d.addEventListener('click', () => { stop(); show(+d.dataset.go); }));
      el.addEventListener('mouseenter', () => { clearInterval(timer); el.classList.add('is-paused'); });
      el.addEventListener('mouseleave', () => { el.classList.remove('is-paused'); start(); });
      el.addEventListener('focusin', () => { clearInterval(timer); el.classList.add('is-paused'); });
      el.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); stop(); show(i + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
      let x0 = null;
      el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { stop(); show(i + (dx < 0 ? 1 : -1)); }
      });
      if (!auto) el.classList.add('is-stopped');
      start();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* Asama home. Cursor parallax on the hero object: translate up to 12px,
   300ms house ease (set in CSS). Off for touch, coarse pointers and
   reduced motion. */
(() => {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const MAX = 12;
  const clamp = (n) => Math.max(-1, Math.min(1, n));

  document.querySelectorAll('.a-hero').forEach((hero) => {
    const target = hero.querySelector('.a-hero__move');
    if (!target) return;

    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      const x = clamp(((e.clientX - r.left) / r.width - 0.5) * 2) * MAX;
      const y = clamp(((e.clientY - r.top) / r.height - 0.5) * 2) * MAX;
      target.style.transform = `translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0)`;
    });

    hero.addEventListener('pointerleave', () => {
      target.style.transform = '';
    });
  });
})();
